import React from 'react'
import ArrowLeftSvg from 'images/modules/Shared/i-arrow-left-customer.svg?raw'

export { default as ArrowLeftCustomerUrl } from 'images/modules/Shared/i-arrow-left-customer.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: ArrowLeftSvg}} />
)
